/* eslint-disable */

import { makeStyles } from '@mui/styles'
import theme from 'theme'

export const useStyles = makeStyles( () => ({
	// Aligns the footer nav strip with the page's own 185px label column
	// (see TechStack/styles.js for the same technique). 1px less than the
	// content offset to absorb the footer's own left border.
	footerNav: {
		[theme.breakpoints.up('laptop')]: {
			marginLeft: '184px',
		},
	},
	// Pentagon mesh (desktop), Tech-mesh style. Two rows of 5 cells
	// (100x95 units each, side vertices at 36/95). Within a row,
	// neighbours share their SIDE edges: the point-up tile's right edge
	// (100,36)->(82,95) is congruent to the point-down tile's left edge
	// (18,0)->(0,59), so each next tile sits at (+82,+36) of the
	// previous one. The second row is the first one FLIPPED and set 95
	// units lower: its point-down tiles sit directly under the row-1
	// point-up tiles, mating flat-bottom-to-flat-top over the full
	// 64-unit edge, while its point-up tiles' peaks meet the row-1
	// hanging tips point-to-point. Their upper edges then run collinear
	// with the row-2 down-tiles' lower edges (the 36/95 vertex height
	// makes both slopes (50,36) and the offsets line up), so the mesh
	// closes itself everywhere except four small triangles (50x36x59
	// legs) flanking the row-1 tips — drawn by interRowRhombus below.
	// Grid: 428x226 units -> container aspect 226/428 = 52.8%
	// (percentage-padding trick, so no aspect-ratio collapse like the
	// earlier grid attempt). Tile width 100/428 = 23.36%, step
	// 82/428 = 19.16%, height 95/226 = 42.04%; row tops
	// (row*95 + 36-if-odd-position)/226.
	domainRibbon: {
		position: 'relative',
		width: '100%',
		height: 0,
		paddingTop: '52.804%',
		// Soft outer glow along the mesh silhouette. drop-shadow follows the
		// union of the children's alpha (the pentagons' opaque var(--bg)
		// fills), so it only shows outside the outer zigzag edges — interior
		// cell borders cast nothing.
		filter: 'drop-shadow(0 0 4px var(--glow)) drop-shadow(0 0 14px var(--glow))',
	},
	// Mobile: vertical stack. A point-up tile's flat bottom edge and the
	// next (point-down) tile's flat top edge are the same width, so
	// flush-stacked pairs share that edge with no positioning math.
	domainColumn: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	// The hover fill is cropped by clip-path; the visible outline is the
	// SVG polygon child (a plain CSS `border` never traces clip-path
	// edges — it stays rectangular and just gets cropped). clip-path also
	// scopes hit-testing, so hover only fires inside the pentagon even
	// though neighbouring tiles' bounding boxes overlap in the ribbon.
	domainPentagon: {
		position: 'relative',
		width: '260px',
		height: '247px',
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		color: 'var(--ink)',
		// Opaque fill (same as the page background) so the ribbon container's
		// drop-shadow sees the pentagon silhouette in the alpha channel.
		backgroundColor: 'var(--bg)',
		transition: 'background-color 0.25s ease',
		'&:hover': {
			backgroundColor: 'var(--hover)',
		},
		[theme.breakpoints.up('laptop')]: {
			position: 'absolute',
			width: '23.3645%',
			height: '42.0354%',
		},
	},
	domainPentagonUp: {
		clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)',
	},
	domainPentagonDown: {
		clipPath: 'polygon(50% 100%, 100% 62%, 82% 0%, 18% 0%, 0% 62%)',
	},
	domainPentagonOutline: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		pointerEvents: 'none',
	},
	// Triangle filler (50x59-unit bounding box) for the holes flanking
	// the row-1 hanging tips: spans y 95..154 (from the row-1
	// flat-bottom level down to the row-2 down-tiles' side vertices).
	// Purely decorative.
	interRowRhombus: {
		position: 'absolute',
		top: '42.0354%',
		width: '11.6822%',
		height: '26.1062%',
		pointerEvents: 'none',
	},
}))